/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * EyeOffIcon
 */
export default class EyeOffIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M10 5.2c.7-.1 1.4-.2 2-.2 5.4 0 8.9 5.4 9.9 7-.6 1-1.2 1.8-1.8 2.5-.4.4-.3 1 .1 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3.8-.9 1.6-2 2.3-3.4.2-.3.2-.6 0-.9C23.7 11.2 19.5 3 12 3c-.8 0-1.5.1-2.2.2-.6.1-1 .6-.9 1.1.1.6.6 1 1.1.9zM23.7 22.3L10.6 9.2 1.7.3C1.3-.1.7-.1.3.3s-.4 1 0 1.4L4.6 6C2.7 7.6 1.2 9.5.1 11.5c-.1.3-.2.6 0 .9.2.4 4.4 8.6 11.9 8.6 2.1-.1 4.1-.7 5.7-1.8l4.5 4.5c.2.2.5.3.7.3s.5-.1.7-.3c.5-.4.5-1 .1-1.4zM10 11.5l2.5 2.5c-.1 0-.3 0-.5.1-.5 0-1-.2-1.4-.6-.6-.6-.8-1.4-.6-2zm2 7.5c-5.4 0-8.9-5.4-9.9-7 1-1.7 2.3-3.2 3.9-4.5L8.6 10c-1 1.5-.8 3.5.6 4.9.7.7 1.7 1.1 2.7 1.1h.1c.7 0 1.4-.2 2-.6l2.3 2.3c-1.3.8-2.8 1.2-4.3 1.3z"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

